import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getPaths } from '../../utils/element';
export const customWorkTimesApi = createApi({
    reducerPath: 'customWorkTimesApi',
    baseQuery: fetchBaseQuery({ baseUrl: getPaths().app_ajax_store_locator_pin_custom_work_times }),
    endpoints: builder => ({
        getCustomWorkTimes: builder.query({
            query: () => '',
        }),
    }),
});
export const { useGetCustomWorkTimesQuery } = customWorkTimesApi;
